module.exports = __webpack_public_path__ + "img/body.ff9cfd30.svg";